import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://dentalspaces.com';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

const SEO = ({
  title = 'DentalSpaces - Dental Practice Marketplace',
  description = 'The premier marketplace for buying and selling dental practices. Connect with trusted brokers and find your perfect practice.',
  canonical,
  image = DEFAULT_IMAGE,
  type = 'website',
  schemas = [],
  noindex = false,
}) => {
  const fullTitle = title.includes('DentalSpaces') ? title : `${title} | DentalSpaces`;
  const canonicalUrl = canonical ? `${SITE_URL}${canonical}` : null;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:site_name" content="DentalSpaces" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* JSON-LD Schemas */}
      {schemas.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
